import { ReactElement, Fragment } from 'react';
import { LoadingButton } from '@mui/lab';
import { Button } from '@mui/material';

interface IProps {
  buttonName: string;
  styles: Record<string, any>;
  isLoading: boolean;
  handler: () => void;
  disabled?: boolean;
}

const ButtonWithLoading = ({
  buttonName,
  styles,
  isLoading,
  handler,
  disabled,
}: IProps): ReactElement => {
  return (
    <Fragment>
      {isLoading ? (
        <LoadingButton sx={styles} loading={isLoading} disabled>
          loading
        </LoadingButton>
      ) : (
        <Button sx={styles} disabled={disabled} onClick={handler}>
          {buttonName}
        </Button>
      )}
    </Fragment>
  );
};

export default ButtonWithLoading;
